import script from "./EditPriceAdjustmentPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditPriceAdjustmentPanel.vue?vue&type=script&setup=true&lang=ts"

import "./EditPriceAdjustmentPanel.vue?vue&type=style&index=0&id=8fe9cb1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8fe9cb1a"]])

export default __exports__